import styled, { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, colors } = getBaseTheme();

export const Subtitle = styled.div``;
Subtitle.displayName = 'SelectOption';

export const LoadingOverLay = styled.div`
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
    position: absolute;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default css`
    width: 70%;

    div[class*='SelectTrigger'] {
        aria-expanded: true;
    }

    div[class*='SelectOverlay'] {
        top: auto;
        bottom: 100%;
        width: 100vw;
        margin-bottom: 19px;
        box-shadow: none;
        display: flex;
        flex-grow: 1;
        flex-flow: column nowrap;
        max-height: 40vh;
        overflow-x: hidden;
        overflow-y: auto;
        position: absolute;
        z-index: 100;
        background: ${colors.area.default.backgroundColor};
        border-top: 2px solid ${colors.icon.complementaryBackgroundColor};
    }

    div[class*='SelectMenu'] {
        > ul > li {
            > div:not([aria-label~='option-undefined']) {
                height: 6rem;
                border-bottom: 1px solid ${colors.icon.complementaryBackgroundColor};
            }

            [aria-label~='option-undefined'] {
                border-bottom: none;
                height: 3rem;
                font-weight: bold;
                font-size: ${texts.sizes.s.fontSize};
                background-color: ${colors.area.default.complementaryBackgroundColor};
            }
        }
    }

    .logic-app {
        max-width: 70%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &__name {
            margin-bottom: 0;
            > span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &__description {
            color: ${colors.control.focus.complementaryForegroundColor};
            > span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &__more-icon {
            visibility: hidden;
        }
    }
`;
